import { StatusType } from '../types';
import { colors } from '@ardoq/design-tokens';

export const badgeBorderColors: Record<StatusType, string | undefined> = {
  [StatusType.DEFAULT]: colors.borderAction,
  [StatusType.SUCCESS]: colors.borderSuccess,
  [StatusType.WARNING]: colors.borderWarning,
  [StatusType.ERROR]: colors.borderError,
  [StatusType.NEW]: colors.borderBrand,
  [StatusType.INFO]: colors.borderInfo,
  [StatusType.SCENARIO]: colors.surfaceScenario,
  [StatusType.BETA]: colors.blue600,
  [StatusType.TRIAL]: colors.pink600,
  [StatusType.WORKSPACE]: colors.borderBrand,
  [StatusType.SUBTLE]: colors.borderNeutral,
};

export const badgeIconColors: Record<StatusType, string | undefined> = {
  [StatusType.DEFAULT]: colors.icon,
  [StatusType.SUCCESS]: colors.iconSuccess,
  [StatusType.WARNING]: colors.iconWarning,
  [StatusType.ERROR]: colors.iconError,
  [StatusType.NEW]: colors.iconBrand,
  [StatusType.INFO]: colors.iconInfo,
  [StatusType.SCENARIO]: colors.white950,
  [StatusType.BETA]: colors.white950,
  [StatusType.TRIAL]: colors.white950,
  [StatusType.WORKSPACE]: colors.iconBrand,
  [StatusType.SUBTLE]: colors.icon,
};

export const badgeDotFills: Record<StatusType, string | undefined> = {
  [StatusType.DEFAULT]: colors.icon,
  [StatusType.SUCCESS]: colors.iconSuccess,
  [StatusType.WARNING]: colors.iconWarning,
  [StatusType.ERROR]: colors.iconError,
  [StatusType.NEW]: colors.iconBrand,
  [StatusType.INFO]: colors.blue200,
  [StatusType.SCENARIO]: colors.blue700,
  [StatusType.BETA]: colors.blue600,
  [StatusType.TRIAL]: colors.pink600,
  [StatusType.WORKSPACE]: colors.iconBrand,
  [StatusType.SUBTLE]: colors.icon,
};

export const badgeFills: Record<StatusType, string | undefined> = {
  [StatusType.DEFAULT]: colors.surfaceStatusNeutral,
  [StatusType.SUCCESS]: colors.surfaceSuccess,
  [StatusType.WARNING]: colors.surfaceWarning,
  [StatusType.ERROR]: colors.surfaceError,
  [StatusType.NEW]: colors.surfaceBrand,
  [StatusType.INFO]: colors.surfaceInfo,
  [StatusType.SCENARIO]: colors.surfaceScenario,
  [StatusType.BETA]: colors.blue600,
  [StatusType.TRIAL]: colors.pink600,
  [StatusType.WORKSPACE]: colors.surfaceBrand,
  [StatusType.SUBTLE]: colors.bgSubtle,
};

export const badgeTextColors: Record<StatusType, string | undefined> = {
  [StatusType.DEFAULT]: colors.textDefault,
  [StatusType.SUCCESS]: colors.textSuccess,
  [StatusType.WARNING]: colors.textWarning,
  [StatusType.ERROR]: colors.textError,
  [StatusType.NEW]: colors.textBrandLight,
  [StatusType.INFO]: colors.textInfo,
  [StatusType.SCENARIO]: colors.textOnInvertedStrong,
  [StatusType.BETA]: colors.textOnInvertedStrong,
  [StatusType.TRIAL]: colors.textOnInvertedStrong,
  [StatusType.WORKSPACE]: colors.textBrand,
  [StatusType.SUBTLE]: colors.textDefault,
};

export const badgeHover: Partial<Record<StatusType, string>> = {
  [StatusType.BETA]: colors.blue700,
  [StatusType.NEW]: colors.brand700,
  [StatusType.TRIAL]: colors.pink700,
};

export const badgeHoverTextColor: Partial<Record<StatusType, string>> = {
  [StatusType.NEW]: colors.textOnInvertedStrong,
};

export const badgeHoverIconColor: Partial<Record<StatusType, string>> = {
  [StatusType.NEW]: colors.textOnInvertedStrong,
};

export const badgeActive: Partial<Record<StatusType, string>> = {
  [StatusType.BETA]: colors.blue900,
  [StatusType.NEW]: colors.brand900,
  [StatusType.TRIAL]: colors.pink900,
};

export const badgeActiveTextColor: Partial<Record<StatusType, string>> = {
  [StatusType.NEW]: colors.textOnInvertedStrong,
};

export const badgeActiveIconColor: Partial<Record<StatusType, string>> = {
  [StatusType.NEW]: colors.textOnInvertedStrong,
};
